import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectProps
} from '@mui/material';
import React from 'react';

type IFormikControlMethods = {
	onConditionChange?: (val: string) => void;
};

type FormikSelectProps = ISelectFieldProps &
	SelectProps &
	IFormikControlMethods;

const SelectField: React.FC<FormikSelectProps> = ({
	label,
	options,
	onChange,
	onConditionChange,
	...rest
}) => (
	<FormControl fullWidth size="small">
		<InputLabel>{label}</InputLabel>
		<Select
			size="small"
			label={label}
			{...rest}
			onChange={(e, child) => {
				if (onConditionChange) {
					onConditionChange(e.target.value as string);
				}
				return onChange && onChange(e, child);
			}}
		>
			{(options || []).map((o) => (
				<MenuItem key={o.value} value={o.value}>
					{o.label}
				</MenuItem>
			))}
		</Select>
	</FormControl>
);

SelectField.defaultProps = {
	onConditionChange: () => {}
};

export interface ISelectFieldProps {
	options: { value: any; label: string }[];
}

export default SelectField;
